// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../isBefore/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var isBefore = convertToFP(fn, 2);
export default isBefore;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/isBefore/index.js
// module id = 919
// module chunks = 0